import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const { user, loading, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [sending, setSending] = useState(false);

  useEffect(() => {
    if (!loading && user) navigate("/admin/dashboard", { replace: true });
  }, [user, loading, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    setError("");
    const res = await login(email, password);
    setSending(false);
    if (res.ok) navigate("/admin/dashboard");
    else setError(res.error);
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center px-6 grain relative" data-testid="admin-login-page">
      <div className="w-full max-w-sm border border-white/10 bg-[#111] p-10">
        <Link to="/" className="inline-block mb-10" data-testid="admin-login-logo">
          <img src="/logo.png" alt="JCD Customs & Marine logo" className="h-16 w-auto" />
        </Link>
        <h1 className="font-display text-4xl tracking-wide text-white mb-2" data-testid="admin-login-heading">STAFF LOGIN</h1>
        <p className="text-gray-500 text-sm mb-8">Authorised staff only.</p>

        <form onSubmit={submit} className="space-y-6" data-testid="admin-login-form">
          <div className="space-y-2">
            <Label htmlFor="admin-email" className="label-industrial text-gray-400">Email</Label>
            <Input id="admin-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-email-input" className="bg-[#0a0a0a] border-white/15 rounded-none h-12 focus-visible:ring-ember" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="admin-password" className="label-industrial text-gray-400">Password</Label>
            <Input id="admin-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password-input" className="bg-[#0a0a0a] border-white/15 rounded-none h-12 focus-visible:ring-ember" />
          </div>
          {error && (
            <p className="text-sm text-red-400 border border-red-400/30 bg-red-400/10 px-4 py-3" data-testid="admin-login-error">
              {error}
            </p>
          )}
          <button type="submit" disabled={sending} data-testid="admin-login-submit-btn"
            className="w-full label-industrial bg-ember text-white py-4 hover:bg-ember-hover disabled:opacity-50 transition-colors duration-150">
            {sending ? "Signing in..." : "Sign In"}
          </button>
        </form>
        <Link to="/" className="block mt-8 text-xs text-gray-600 hover:text-ember transition-colors duration-150" data-testid="admin-login-back-link">
          Back to site
        </Link>
      </div>
    </div>
  );
}
